export default __webpack_public_path__ + "static/media/laptop.bef72af2.png";